import issuesCalendar from "nd.issuescalendar";
import { httpGet } from "@pressreader/services";

    

    var provider = {};

    provider.load = function (cid) {
    	return httpGet("calendar", "get", { cid: cid });
    };

    issuesCalendar.setProvider(provider);

	export default provider;

